var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "cost-key"
  }, [_vm._v(_vm._s(_vm.field) + ":")]), _c('div', {
    staticClass: "cost-value",
    style: _vm.beyondStyle
  }, [_vm._v(_vm._s(_vm.displayValue))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }